export default __webpack_public_path__ + "static/media/payment-screen-2.cf84d9b0.webp";